import React, { createRef, useEffect } from "react";
import anime from "animejs/lib/anime.es.js";
import styled from 'styled-components';

import Hamster from '@cover/hamsternstoppen/hamster';

const HamsterPosition = styled(Hamster)`
	position: absolute;
`
const HamsterBottom = styled(HamsterPosition)`
	height: 25%;
	bottom: -1.5%;
	left: 3%;
`
const HamsterBottomCenter = styled(HamsterPosition)`
	height: 20.5%;
	bottom: 14.4%;
	left: 32.5%;
`
const HamsterCenterRight = styled(HamsterPosition)`
	height: 23%;
	bottom: 37.5%;
	right: -16%;
`
const HamsterCenterLeft = styled(HamsterPosition)`
	height: 12.2%;
	top: 30.5%;
	left: 20%;
`
const HamsterTopLeft = styled(HamsterPosition)`
	height: 10.8%;
	top: -2.8%;
	left: 13.4%;
`
const HamsterTopCenter = styled(HamsterPosition)`
	height: 14%;
	right: 24%;
	top: 12%;
`
const HamsterTopRight = styled(HamsterPosition)`
	height: 10.5%;
	right: 2%;
	top: 8.5%;
`

const HamsternStoppen = ({ play }) => {
	const hamsterBottomCenter = createRef();
	const hamsterBottom = createRef();
	const hamsterCenterLeft = createRef();
	const hamsterCenterRight = createRef();
	const hamsterTopLeft = createRef();
	const hamsterTopCenter = createRef();
	const hamsterTopRight = createRef();

	useEffect(() => {
		const noseBottomCenter = hamsterBottomCenter.current.querySelector('#hamster_svg__nose')
		const noseBottom = hamsterBottom.current.querySelector('#hamster_svg__nose')
		const noseCenterLeft = hamsterCenterLeft.current.querySelector('#hamster_svg__nose')
		const noseCenterRight = hamsterCenterRight.current.querySelector('#hamster_svg__nose')
		const noseTopLeft = hamsterTopLeft.current.querySelector('#hamster_svg__nose')
		const noseTopCenter = hamsterTopCenter.current.querySelector('#hamster_svg__nose')
		const noseTopRight = hamsterTopRight.current.querySelector('#hamster_svg__nose')

		const h1 = anime.timeline({
			autoplay: play,
			loop: true
		});

		h1
		// hamster top center
		.add({
			targets: hamsterTopCenter.current,
			keyframes: [
				{translateY: '-2%', duration: 200, easing: 'easeInSine',},
				{translateY: '0%', duration: 200, easing: 'easeOutSine',},
				{translateY: '-1%', duration: 200, easing: 'easeInSine',},
				{translateY: '0%', duration: 200, easing: 'easeOutSine', endDelay: 200},
			]
		}, 100)
		.add({
			targets: noseTopCenter,
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: '-0.9%', duration: 200},
				{translateY: '0%', duration: 200},
				{translateY: '-0.9%', duration: 200},
				{translateY: '0%', duration: 200, endDelay: 1000},
			]
		}, 2000)

		// hamster top right
		.add({
			targets: hamsterTopRight.current,
			keyframes: [
				{translateX: '0%', translateY: '0%', duration: 200, endDelay: 2000, easing: 'steps(2)'},
				{translateX: '2%', translateY: '2%', duration: 400, endDelay: 1200, easing: 'steps(2)'},
				{translateX: '0%', translateY: '0%', duration: 200, endDelay: 2200, easing: 'steps(3)'},
			]
		}, 900)
		.add({
			targets: noseTopRight,
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: '-0.9%', duration: 200},
				{translateY: '0%', duration: 200},
				{translateY: '-0.9%', duration: 200},
				{translateY: '0%', duration: 200, endDelay: 600},
				{translateY: '-0.9%', duration: 200},
				{translateY: '0%', duration: 200, endDelay: 1000},
				{translateY: '-0.9%', duration: 200},
				{translateY: '0%', duration: 200, endDelay: 900},
				{translateY: '-0.9%', duration: 200},
				{translateY: '0%', duration: 200},
			]
		}, 1200)

		// hamster top left
		const h2 = anime.timeline({
			autoplay: play,
			loop: true
		});

		h2
		.add({
			targets: hamsterTopLeft.current,
			keyframes: [
				{translateY: '-2%', duration: 200, easing: 'easeInSine'},
				{translateY: '0%', duration: 200, easing: 'easeOutSine'},
				{translateY: '-2%', duration: 200, easing: 'easeInSine'},
				{translateY: '0%', duration: 200, easing: 'easeOutSine', endDelay: 1000},
			]
		}, 1600)
		.add({
			targets: noseTopLeft,
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: '-0.9%', duration: 200},
				{translateY: '0%', duration: 200},
				{translateY: '-0.9%', duration: 200},
				{translateY: '0%', duration: 200, endDelay: 1000},
			]
		}, 2000)

		// hamster center right
		.add({
			targets: hamsterCenterRight.current,
			keyframes: [
				{translateX: '1%', duration: 400, endDelay: 800, easing: 'steps(1)'},
				{translateX: '0%', duration: 200, endDelay: 600, easing: 'steps(2)'},
				{translateX: '2%', duration: 400, endDelay: 1000, easing: 'steps(3)'},
				{translateX: '0%', duration: 200, endDelay: 200, easing: 'steps(2)'},
				{translateY: '-2%', duration: 200, easing: 'easeInSine'},
				{translateY: '0%', duration: 200, easing: 'easeOutSine', endDelay: 1000},
			]
		}, 100)

		// hamster center left
		const h3 = anime.timeline({
			autoplay: play,
			loop: true
		});

		h3
		.add({
			targets: hamsterCenterLeft.current,
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: '-1.5%', duration: 150, easing: 'easeInSine'},
				{translateY: '0%', duration: 150, easing: 'easeOutSine'},
				{translateY: '-1.5%', duration: 150, easing: 'easeInSine'},
				{translateY: '0%', duration: 150, easing: 'easeOutSine', endDelay: 1000},
			]
		}, 1200)
		.add({
			targets: noseCenterLeft,
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: '-0.9%', duration: 200},
				{translateY: '0%', duration: 200},
				{translateY: '-0.9%', duration: 200},
				{translateY: '0%', duration: 200},
			]
		}, 100)

		// hamster bottom center
		.add({
			targets: hamsterBottomCenter.current,
			easing: 'steps(3)',
			keyframes: [
				{translateY: '0%', duration: 200, endDelay: 4000, easing: 'steps(2)'},
				{translateY: '2%', duration: 400, endDelay: 900, easing: 'steps(3)'},
				{translateY: '0%', duration: 200, endDelay: 1000, easing: 'steps(2)'},
			]
		}, 1000)
		.add({
			targets: noseBottomCenter,
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: '-0.9%', duration: 150},
				{translateY: '0%', duration: 150},
				{translateY: '-0.9%', duration: 150},
				{translateY: '0%', duration: 150, endDelay: 800},
				{translateY: '-0.9%', duration: 150},
				{translateY: '0%', duration: 150},
				{translateY: '-0.9%', duration: 150},
				{translateY: '0%', duration: 150, endDelay: 1000},
			]
		}, 300)

		// hamster bottom left
		.add({
			targets: hamsterBottom.current,
			easing: 'steps(3)',
			keyframes: [
				{translateY: '-1%', duration: 200, easing: 'easeInSine'},
				{translateY: '0%', duration: 200, easing: 'easeOutSine'},
				{translateY: '-1%', duration: 200, easing: 'easeInSine'},
				{translateY: '0%', duration: 200, easing: 'easeOutSine', endDelay: 1000},
			]
		}, 200)
		.add({
			targets: noseBottom,
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: '-0.9%', duration: 200},
				{translateY: '0%', duration: 200},
				{translateY: '-0.9%', duration: 200},
				{translateY: '0%', duration: 200, endDelay: 1000},
				{translateY: '-0.9%', duration: 200},
				{translateY: '0%', duration: 200, endDelay: 800},
				{translateY: '-0.9%', duration: 200},
				{translateY: '0%', duration: 200},
				{translateY: '-0.9%', duration: 200},
				{translateY: '0%', duration: 200, endDelay: 1000},
			]
		}, 1000)
	}, [play])
	return (
		<>
			<HamsterBottomCenter ref={hamsterBottomCenter}/>
			<HamsterBottom ref={hamsterBottom}/>
			<HamsterCenterLeft ref={hamsterCenterLeft}/>
			<HamsterCenterRight ref={hamsterCenterRight}/>
			<HamsterTopLeft ref={hamsterTopLeft}/>
			<HamsterTopCenter ref={hamsterTopCenter}/>
			<HamsterTopRight ref={hamsterTopRight}/>
		</>
	)
};

export default HamsternStoppen;